import { Button } from 'src/components/reusable/Buttons';
import Image from '../reusable/Image';
import TransactionHistory from 'src/assets/images/transaction-history.png';

interface AuthImage {
  buttonText: string;
  handleClick: () => void;
}

const AuthImage = ({ buttonText, handleClick }: AuthImage) => {
  return (
    <div className="auth-image bg-[#F5F7F9] auth-pattern rounded-lg">
      <div className="flex justify-end px-8 py-6">
        <Button
          className="px-6 font-medium"
          variant="primary"
          onClick={handleClick}
        >
          {buttonText}
        </Button>
      </div>
      <div className="relative pl-12">
        <Image
          src={TransactionHistory}
          className="w-full object-cover flex justify-end"
        />
      </div>
    </div>
  );
};

export default AuthImage;
